import { render, staticRenderFns } from "./KuaishouNew.vue?vue&type=template&id=61972ea1&scoped=true"
import script from "./KuaishouNew.vue?vue&type=script&lang=js"
export * from "./KuaishouNew.vue?vue&type=script&lang=js"
import style0 from "./KuaishouNew.vue?vue&type=style&index=0&id=61972ea1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61972ea1",
  null
  
)

export default component.exports